var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 305.004 305.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.788 181.868h27.583a9.5 9.5 0 0 0 9.5-9.5v-60.149a9.5 9.5 0 0 0-9.5-9.5H68.788a9.5 9.5 0 0 0-9.5 9.5v60.149a9.5 9.5 0 0 0 9.5 9.5m69.922 0h27.583a9.5 9.5 0 0 0 9.5-9.5V84.174a9.5 9.5 0 0 0-9.5-9.5H138.71a9.5 9.5 0 0 0-9.5 9.5v88.195c0 5.246 4.253 9.499 9.5 9.499m69.922 0h27.583a9.5 9.5 0 0 0 9.5-9.5v-19.195a9.5 9.5 0 0 0-9.5-9.5h-27.583a9.5 9.5 0 0 0-9.5 9.5v19.195a9.5 9.5 0 0 0 9.5 9.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.668 22.769H167.502V15c0-8.284-6.716-15-15-15s-15 6.716-15 15v7.769H14.335a9.5 9.5 0 0 0-9.5 9.5v195a9.5 9.5 0 0 0 9.5 9.5h123.167v20.719L97.15 276.42c-7.5 3.52-10.728 12.451-7.209 19.951 3.518 7.5 12.451 10.727 19.951 7.209l28.25-13.254C140 296.5 145.723 301 152.502 301s12.502-4.5 14.36-10.673l28.25 13.254c7.507 3.52 16.435.285 19.951-7.209 3.519-7.5.291-16.432-7.209-19.951l-40.352-18.932V236.77h123.167a9.5 9.5 0 0 0 9.5-9.5v-195c-.001-5.248-4.254-9.501-9.501-9.501m-20.5 184H34.835v-154h235.333z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graph-icon.6d46d5fc4adb5c37fa3ed1d85041f16c.svg";
export { ForwardRef as ReactComponent };